import { isBoolean, isFunction, isUndefined } from '@skylab-shared/utils';

export interface IMenuItem<TContext> {
    label: string;
    //TODO: w taki sposób żeby nic przed wersją nie zepsuć
    dynamicLabel?: (context?: TContext) => void;
    icon?: string;
    getIcon?: () => string;
    submenu?: MenuItem[];
    separator?: boolean;
    disabled?: ((context?: TContext) => boolean) | boolean;
    click?: (context?: TContext) => void;
    closeAfterClick?: boolean;
}

export class MenuItem<TContext = any> {
    public label!: string;
    public icon?: string;
    public submenu?: MenuItem[];
    public disabled?: ((context?: TContext) => boolean) | boolean;
    public click?: (context?: TContext) => void;
    public dynamicLabel?: (context?: TContext) => void;
    public getIcon?: () => string;
    public closeAfterClick = true;

    public separator?: boolean;
    public isActive?: boolean;

    public constructor(config?: IMenuItem<TContext>) {
        if (config) {
            this.label = config.label;
            this.icon = config.icon;
            this.submenu = config.submenu;
            this.disabled = config.disabled;
            this.click = config.click;
            this.dynamicLabel = config.dynamicLabel;
            this.getIcon = config.getIcon;
            this.separator = config.separator;
            this.closeAfterClick = config.closeAfterClick ?? true;
        }
    }

    public isDisabled(context: TContext): boolean {
        if (isFunction(this.disabled)) {
            return this.disabled(context);
        }
        if (isBoolean(this.disabled)) {
            return this.disabled;
        }
        return false;
    }
}

export interface IMenuItemOption<TContext> extends IMenuItem<TContext> {
    identityName?: string;
    isChecked?: boolean;
    disableIcon?: boolean;
}

export class MenuItemOption<TContext = any> extends MenuItem<TContext> {
    public identityName?: string;
    public isChecked?: boolean;
    public disableIcon?: boolean;

    public constructor(config: IMenuItemOption<TContext>) {
        super(config);
        this.identityName = config.identityName;
        this.isChecked = config.isChecked;
        this.disableIcon = config.disableIcon;
    }
}

export class MenuItemSeparator extends MenuItem {
    public constructor() {
        super();
    }
}

export enum MenuType {
    Context = 'Context',
    Options = 'Options',
    Pointer = 'Pointer',
    Sub = 'Sub'
}

export interface MenuOptions<TContext = any> {
    showDisabled?: boolean;
    hideOnScroll?: boolean;
    type?: MenuType;
    getContext?: () => TContext | null;
}

export class Menu<TContext = any> {
    public items: MenuItem[] = [];
    public showDisabled: boolean = true;
    public hideOnScroll: boolean = true;
    public type: MenuType = MenuType.Pointer;
    public getContext?: () => TContext | null;

    public constructor(items: MenuItem[], options?: MenuOptions<TContext>) {
        if (options) {
            if (!isUndefined(options.showDisabled)) this.showDisabled = options.showDisabled;
            if (!isUndefined(options.hideOnScroll)) this.hideOnScroll = options.hideOnScroll;
            if (!isUndefined(options.type)) this.type = options.type;
            if (!isUndefined(options.getContext)) this.getContext = options.getContext;
        }

        if (items) {
            items.filter(Boolean).forEach(this.addItem.bind(this));
        }
    }

    public addItem(item: MenuItem<TContext>): void {
        if (item instanceof MenuItemSeparator) {
            if (this.items) {
                this.items[this.items.length - 1].separator = true;
            }
        } else {
            this.items.push(item as MenuItem<any>);
        }
    }

}
